import React from "react";
import ReactDOM from "react-dom";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";

const Tooltip = props => {
    const [visible, setVisible] = useState(false);
    const [style, setStyle] = useState({});
    const ref = useRef();

    const width = props.width || 256;
    const space = props.space || 5;

    const showTooltip = () => {
        const style = { width };
        const dimensions = ref.current.getBoundingClientRect();
        style.left = (dimensions.left + (dimensions.width / 2)) - (width / 2);
        style.left = Math.max(space, style.left);
        style.left = Math.min(style.left, document.body.clientWidth - width - space);

        if (dimensions.top < window.innerHeight / 2) {
            style.top = dimensions.top + dimensions.height + space;
        } else {
            style.bottom = (window.innerHeight - dimensions.top) + space;
        }

        setVisible(true);
        setStyle(style);
    }

    const hideTooltip = () => setVisible(false);

    return (
        <span
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
            className="tooltip-trigger-text"
            ref={ref}
        >
            {props.children}

            {visible && (
                <MyPortal>
                    <div
                        className="tooltip-body"
                        style={style}
                    >
                        {props.text}
                    </div>
                </MyPortal>
            )}
        </span>
    );
}

const MyPortal = props => {
    const el = document.createElement("div");

    useEffect(() => {
        document.body.appendChild(el);

        return () => document.body.removeChild(el);
    }, []);

    return ReactDOM.createPortal(props.children, el);
}

export default Tooltip;